module.exports = __webpack_public_path__ + "img/network_device.1d594672.svg";